export const en = {
    number: '№ {id}'
};
